module.exports = __webpack_public_path__ + "static/media/Illustration.bbd05844.svg";